import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-alarm-detail',
  templateUrl: './alarm-detail.component.html',
  styleUrls: ['./alarm-detail.component.scss'],
})
export class AlarmDetailComponent implements OnInit {
  alarms$: Observable<any>; //알림 데이터
  constructor(private db: DbService) {}

  ngOnInit() {
    this.getData();
  }

  ngOnDestroy() {
    this.upDateRead();
  }

  //알림 데이터 불러오기
  getData() {
    this.alarms$ = this.db.collection$('notification', (ref) =>
      ref.where('uid', '==', 'admin').orderBy('dateCreated', 'desc')
    );
  }

  //읽음 여부 업데이트
  upDateRead() {
    this.alarms$.pipe(take(1)).subscribe((val) => {
      val.forEach((v) => {
        if (!v.readSwitch) {
          this.db.updateAt(`notification/${v.id}`, { readSwitch: true });
        }
      });
    });
  }
}
